import { connect } from 'react-redux';
import StudentNumber from '../../../views/Student/report/StudentNumber.student.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(StudentNumber);
